import {useState} from 'react';
// import {AxiosError} from 'axios';
import {useAuthedMutation} from './QueryHooks';
import {ReadAll} from '../types/Notifications';

const useNotifyReadAll = () => {
	const {mutate} = useAuthedMutation<ReadAll>(`notifications/enterpriser/read-all?`);
	const [errorMessage, setErrorMessage] = useState<string | null>(null);
	const readAll = async () => {
		try {
			await mutate({});
		} catch (error) {
			// eslint-disable-next-line @typescript-eslint/ban-ts-comment
			// @ts-ignore

			setErrorMessage(error?.response?.data?.message);
		}
	};

	return {readAll, errorMessage};
};

export default useNotifyReadAll;
